import ProjectConfigResponseResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigResponseResource";
import { useProjectId } from "hooks/useProjectId";
import { useCallback, useEffect, useState } from "react";
import ConfigService from "services/projects/ConfigService";
import { container } from "tsyringe";

const configService = container.resolve(ConfigService);

export const useProjectConfig = () => {
	const { projectId } = useProjectId();
	const [projectConfig, setProjectConfig] = useState<ProjectConfigResponseResource | null>(null);

	const fetchProjectConfig = useCallback(async () => {
		configService.getByProjectId(projectId).then(setProjectConfig);
	}, [projectId]);

	useEffect(() => {
		fetchProjectConfig();
	}, [fetchProjectConfig]);

	return { projectConfig };
};
